/* eslint-disable react/jsx-props-no-spreading */
import BreadCrumbs from 'modules/common/BreadCrumbs';
import Container from 'modules/common/Container';
import Head from 'modules/common/Head';
import NewDesignButton from 'modules/common/NewDesignButton';
import TrackCompleted from 'modules/common/Svg/TrackCompleted';
import TrackCompletion from 'modules/common/Svg/TrackCompletion';
import TrackTime from 'modules/common/TrackTime';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import BootcampEvents from './BootcampEvents';
import TrackCourse from './TrackCourse';
import BootcampCourse from './BootcampCourse';
import TrackCourseItem from './TrackCourseItem';
import TrackHeader from './TrackHeader';
import TrackTrailer from './TrackTrailer';

const {PARTNER} = process.env;

const TrackDetails = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    authenticated,
    availableCertificates,
    coursesProgress,
    isDegree,
    track = {},
    trackProgress,
    stagesProgress,
    stepsProgress,
    subscription,
  } = props;
  const trackId = track && track.id;
  const linkedBootcamp = track && track.linkedDegree;
  const bootcampName = linkedBootcamp && linkedBootcamp.name;
  const bootcampSlug = linkedBootcamp && linkedBootcamp.slug;
  const trackName = track && track.name;
  const trackSlug = track && track.slug;
  const isBarmejFundamentalTrack = !isDegree && PARTNER === 'BARMEJ';
  const [isBootcampEventsVisible, setBootcampEventsVisible] = useState(false);

  const toggleBootcampEvents = () => {
    setBootcampEventsVisible(!isBootcampEventsVisible);
  };
  return (
    <>
      <Head
        name={track.metaTitle}
        title={`${track.metaTitle} | ${formatMessage({
          id: PARTNER === 'BARMEJ' ? 'helmet_barmej' : 'partner_helmet',
        })}`}
        description={
          track.metaDescription &&
          track.metaDescription.replace(/<\/?[^>]+(>|$)/g, '')
        }
      />
      <TrackTime
        message={`Time on ${isDegree ? 'degree' : 'track'} ${track.name}`}
      />
      <TrackHeader
        {...track}
        authenticated={authenticated}
        isDegree={isDegree}
        stagesProgress={stagesProgress}
        stepsProgress={stepsProgress}
        trackProgress={trackProgress}
        trackSlug={track.slug}
        isBootcampEventsVisible={isBootcampEventsVisible}
        toggleBootcampEvents={toggleBootcampEvents}
        subscription={subscription}
      />
      <BreadCrumbs
        steps={[
          {
            text: formatMessage({
              id: 'homepage',
            }),
            url: '/',
          },
          {
            text: formatMessage({
              id: 'tracks',
            }),
            url: '/tracks',
          },
          {
            text: track.name,
            url: isDegree ? `/degrees/${track.slug}` : `/${track.slug}`,
          },
        ]}
      />
      <Container className="pt3 pt4-ns">
        <div className="tc">
          {authenticated &&
            !isBarmejFundamentalTrack &&
            trackId &&
            trackName &&
            trackSlug &&
            PARTNER && (
              <div
                className="mb4"
                style={{
                  display: isBootcampEventsVisible ? 'block' : 'none',
                }}
              >
                <BootcampEvents
                  degreeId={trackId}
                  degreeName={trackName}
                  degreeSlug={trackSlug}
                  partner={PARTNER}
                />
              </div>
            )}
          <div
            style={{
              display: !isBootcampEventsVisible ? 'block' : 'none',
            }}
          >
            {track.trailerYoutubeId && (
              <div className="mv3">
                <TrackTrailer
                  trailerYoutubeId={track.trailerYoutubeId}
                  trackName={track.name}
                />
              </div>
            )}
            {track.courses &&
              track.courses.map((course, i) => {
                return (
                  <TrackCourseItem
                    key={i}
                    step={i + 1}
                    courseProgress={coursesProgress[course.id] || 'not started'}
                    last={track.courses.length - 1 === i}
                  >
                      <TrackCourse
                        authenticated={authenticated}
                        {...course}
                        trackSlug={track.slug}
                        trackID={track.id}
                        courseProgress={
                          coursesProgress[course.id] || 'not started'
                        }
                        stepsProgress={stepsProgress}
                        stagesProgress={stagesProgress}
                        isDegree={isDegree}
                        subscription={subscription}
                      />
                  </TrackCourseItem>
                );
              })}
          </div>
        </div>
        <div
          className="tc lh-copy b mid-gray mv5"
          style={{
            display: !isBootcampEventsVisible ? 'block' : 'none',
          }}
        >
          {trackProgress === 'completed' ? (
            <div>
              {PARTNER === 'BARMEJ' &&
                !isDegree &&
                availableCertificates.status === 'fetched' &&
                availableCertificates.data.length > 0 &&
                availableCertificates.data.some(({id}) => id === track.id) && (
                  <div className="cf">
                    <NewDesignButton
                      link={`/account/certificates/${track.id}`}
                      className="pv3 ph4 mb4 bg-green-light bg-animate hover-bg-green"
                    >
                      <FormattedMessage id="obtain_certificate" />
                    </NewDesignButton>
                  </div>
                )}
              <TrackCompleted color="#D4E3FF" primaryColor="#7EABFF" />
              <p className="mt2">
                <FormattedMessage id="completed" defaultMessage="COMPLETED" />
              </p>
            </div>
          ) : (
            <div>
              <TrackCompletion />
              <p className="mt2">
                <FormattedMessage id="completion" />
              </p>
            </div>
          )}
          <p>
            <FormattedMessage id={isDegree ? 'degree' : 'track'} />
          </p>
        </div>
      </Container>
    </>
  );
};

TrackDetails.propTypes = {
  isDegree: PropTypes.bool,
  track: PropTypes.shape({
    companiez: PropTypes.string,
    courses: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        duration: PropTypes.number,
        date: PropTypes.string,
        remaining_time: PropTypes.number,
        stages: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string,
            position: PropTypes.number,
          }),
        ),
      }),
    ).isRequired,
    description: PropTypes.string.isRequired,
    duration: PropTypes.number,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    trailerYoutubeId: PropTypes.string,
    slug: PropTypes.string.isRequired,
    linkedDegree: PropTypes.object,
    eventSet: PropTypes.object,
  }).isRequired,
  coursesProgress: PropTypes.object.isRequired,
  trackProgress: PropTypes.string.isRequired,
  stagesProgress: PropTypes.object.isRequired,
  stepsProgress: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
  availableCertificates: PropTypes.object,
  activatedAt: PropTypes.string,
};

export default TrackDetails;
